import React from 'react';

const ModalHeading = ({ heading, subHeading, onClose }) => {
	return (
		<div className='modal__heading--container'>
			<div>
				<h2 className='modal__heading2' data-testid='modal-heading'>
					{heading}
				</h2>
				{subHeading && <p className='modal__sub_heading'>{subHeading}</p>}
			</div>
			{onClose && (
				<button onClick={onClose} className='modal__heading--btn' title='Close'>
					<svg className='modal__heading--icon' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path d='M18 6L6 18M6 6L18 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
					</svg>
				</button>
			)}
		</div>
	);
};

export default ModalHeading;
